import react, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Menu from "../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import Table from "../../../Layout/Table/Table";
import { Puff } from "react-loading-icons";
import {
  Input,
  TextArea,
  Select,
  SelectCountries,
  InputImage,
  Switch,
} from "../../../Layout/Forms/Form";
import BillingRequests from "../BillingRequests";
import "../Billing.css";
import BillingNavigation from "../BillingNavigation";
import ModalPlans from "../Plans/Plans";
import NavBar from "../../../../components/NavBar";

const BillingManager = () => {
  const navigate = useNavigate();
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    product: {
      description: "",
    },
    product_lines: [],
    billing_account: {
      id: 0,
      name_company: "",
      nipc: "",
      email: "",
      phone_country: "",
      phone_number: "",
      address: "",
      city: "",
      postal_code: "",
      country: "",
    },
    sponsor_plan: [],
    modalPlans: {
      show: false,
      id_venues: 0,
      id_events: 0,
    },
  });

  const requestBillingSubscritionInfo = async () => {
    setIsLoading(true);
    document.title = "Billing Subscriptions Info | Nightspot Dashboard";
    let info = await BillingRequests.getSubscritionInfo(params);
    if (info && info.status) {
      setData(info.data);
    }
    setIsLoading(false);
  };

  useEffect(async () => {
    requestBillingSubscritionInfo();
  }, []);

  const handlerSubmitPlan = async (plan) => {
    setIsLoading(true);
    let info = await BillingRequests.setSubscriptionPlan({
      plan: plan,
      id_venues: params.id_venues,
    });
    if (info && info.status) {
      navigate(info.redirect);
    }
    setIsLoading(false);
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const translateUnits = (unit) => {
    const units = {
      un: "",
      days: "Dias",
    };
    return units[unit] ? units[unit] : null;
  };

  const ListCurrentPlan = () => {
    const Lines = () => {
      return data.product_lines.map((item, key) => {
        if (item.unit == "un" || item.unit == "days") {
          return (
            <li key={key}>
              <span className="me-2">{item.label}:</span>
              {item.usage} / {item.limits} {translateUnits(item.unit)}
            </li>
          );
        } else if (item.unit === "check") {
          return (
            <li key={key}>
              <span className="me-2">{item.label}</span>
              {item.quantity ? (
                item.quantity == 1 ? (
                  <i className="fa-solid fa-circle-check"></i>
                ) : (
                  <i className="fa-solid fa-ban"></i>
                )
              ) : null}
            </li>
          );
        } else {
          return null;
        }
      });
    };

    return (
      <ul className="nav-billing less-space">
        <li>
          <span>Plano:</span> {data.product.description}{" "}
        </li>
        {data.product.reference != "FREE" ? (
          <li>
            <span>As contagens renovam em:</span> {data.product.date_end}{" "}
          </li>
        ) : null}
        <Lines />
      </ul>
    );
  };

  const ButtonCurrentPlan = () => {
    const btn_change_plan = () => {
      return (
        <button
          onClick={() =>
            setData({
              ...data,

              modalPlans: {
                ...data.modalPlans,
                show: true,
              },
            })
          }
          className="btn btn-primary w-100"
        >
          <i className="fa-solid fa-arrow-up-from-bracket"></i>&nbsp;Alterar
          plano
        </button>
      );
    };

    const btn_renew_plan = () => {
      return (
        <button
          onClick={() =>
            setData({
              ...data,

              modalPlans: {
                ...data.modalPlans,
                show: true,
              },
            })
          }
          className="btn btn-primary w-100"
        >
          <i className="fa-solid fa-arrow-up-from-bracket"></i>&nbsp;Renovar
          plano
        </button>
      );
    };

    const btn_pending_payment = () => {
      return (
        <>
          <div className="row mb-2">
            <div className="col-12">
              <div className="alert alert-warning">
                Têm um pagamento pendente, efetue o pagamento e aproveite as
                funcionalidades da plataforma.
              </div>
            </div>
          </div>
          <Link
            className="btn btn-primary w-100"
            to={`/my/billing/checkout/${data.sponsor_plan.id}/finish`}
          >
            <i className="fa-solid fa-arrow-up-from-bracket"></i>&nbsp;Efetuar
            pagamento
          </Link>
        </>
      );
    };

    if (!data.sponsor_plan) {
      return btn_change_plan();
    }
    if (data.sponsor_plan.status == "ACTIVE") {
      return btn_change_plan();
    } else if (data.sponsor_plan.status == "EXPIRED") {
      return btn_renew_plan();
    } else if (data.sponsor_plan.status == "PENDING_PAYMENT") {
      return btn_pending_payment();
    }
    return null;
  };

  const BillingAccountDetails = () => {
    return (
      <ul className="nav-billing less-space">
        <li>
          <span>Nome Empresa:</span> {data.billing_account.name_company}{" "}
        </li>
        <li>
          <span>NIF:</span> {data.billing_account.nipc}{" "}
        </li>
        <li>
          <span>Email:</span> {data.billing_account.email}{" "}
        </li>
        <li>
          <span>Telefone:</span> {data.billing_account.phone_number}{" "}
        </li>
        <li>
          <span>Rua:</span> {data.billing_account.address}{" "}
        </li>
        <li>
          <span>Cidade:</span> {data.billing_account.city}{" "}
        </li>
        <li>
          <span>Código Postal:</span> {data.billing_account.postal_code}{" "}
        </li>
        <li>
          <span>País:</span> {data.billing_account.country}{" "}
        </li>
      </ul>
    );
  };

  return (
    <>
      <div>
        <NavBar>
          <div className="row">
            <div className="col-sm-12 dashboard-content">
              {isLoading ? (
                <InsideLoading />
              ) : (
                <>
                  <div className="row">
                    <div className="col-8">
                      <h2 className="dashboard-h2">Planos e Faturação</h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <nav>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to="/my/dashboard">
                              <i className="fa-solid fa-home"></i>
                            </Link>
                          </li>
                          <li className="breadcrumb-item">
                            <Link to="/my/nightspots">Lista Nightspots</Link>
                          </li>
                          <li className="breadcrumb-item active">
                            Gestão de subscrição
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12">
                      <div className="row mt-3">
                        <div className="col-5 col-sm-3 ">
                          <BillingNavigation tab="manager" />
                        </div>
                        <div className="col-7 col-sm-9 container">
                          <div className="row">
                            <div className="col-12 col-sm-6">
                              <div
                                className="p-3 h-100"
                                style={{
                                  backgroundColor: " #0a1116",
                                  borderRadius: "8px",
                                }}
                              >
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row ">
                                      <div className="col-12">
                                        <h4>Subscrição</h4>
                                        <div className="divisor"></div>
                                        <ListCurrentPlan />
                                      </div>
                                    </div>

                                    <div className="row ">
                                      <div className="col-12">
                                        <ButtonCurrentPlan />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                              <div
                                className="p-3 h-100"
                                style={{
                                  backgroundColor: " #0a1116",
                                  borderRadius: "8px",
                                }}
                              >
                                <div className="row">
                                  <div className="col-12">
                                    <h4>Dados Faturação</h4>
                                    <div className="divisor mb-3"></div>
                                    <BillingAccountDetails />
                                    <Link
                                      to="/my/billing/account"
                                      className="btn btn-primary w-100"
                                    >
                                      <i className="fa-solid fa-edit"></i>
                                      &nbsp;Editar Dados de Faturação
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ModalPlans
                    show={data.modalPlans.show}
                    data={data.modalPlans}
                    handleModalhide={() =>
                      setData({
                        ...data,
                        modalPlans: {
                          ...data.modalPlans,
                          show: false,
                        },
                      })
                    }
                    handlerSubmitPlan={(plan) => handlerSubmitPlan(plan)}
                  />
                </>
              )}
            </div>
          </div>
        </NavBar>
      </div>
    </>
  );
};

export default BillingManager;
